import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';

import CoordsBlock from '@containers/coords-block';
import MiniMapBlock from '@containers/minimap-block';
import MainMap from '@containers/main-map';
import ModeBlock from '@containers/mode-block';
import UserInfoBlock from '@containers/user-info-block';
import LegendBlock from '@components/containers/legend-block';

import {loadData, closePopup, SIZE_CHANGE} from './actions';
//import TestPanelsBlock from '@containers/test-panels-block';
import TopPanelsBlock from '@containers/top-panels-block';

import BLOCKS from '@store/blocks';

import Popup from '@components/common/popup';
import DrillingDBoxBuilder from '@components/containers/popup-types';

import styles from './index.module.css';
import resetStyles from '@styles/reset.module.css';

const MAIN_MAP_WIDTH = 1060;


class App extends Component {
  constructor(props) {
    super(props);

    props.dispatch(loadData);

    this.containerRef = React.createRef();
    this.appRef = React.createRef();

    this.state = {scale: 1};
    this.closePopup = () => {
      props.dispatch(closePopup);
    };
  }

  fit() {
    const containerBox = this.containerRef.current.getBoundingClientRect();

    this.props.dispatch(SIZE_CHANGE, containerBox);
  }

  componentDidMount() {
    this.fit = this.fit.bind(this);

    this.fit();
    window.addEventListener('resize', this.fit);
    window.addEventListener('orientationchange', this.fit);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.fit);
    window.removeEventListener('orientationchange', this.fit);
  }

  render() {
    const DBox = DrillingDBoxBuilder(this.props.showPopup);

    return (<section ref={this.containerRef} className={styles.container}>

      <div
        className={`${styles.app} ${resetStyles.app}`}
        style={{
          'transformOrigin': 'left top',
          'transform': `scale(${1 / this.props.scale})`
        }}>
        <Popup type={this.props.showPopup}>{this.props.showPopup && <DBox onCancel={this.closePopup}/>}</Popup>
        {this.props.loaded &&
        <React.Fragment>
          <div className={styles['top-block']}>
            <TopPanelsBlock/>
          </div>
          <div className={styles['bottom-block']}>
            <div className={styles['bottom-left-block']}>
              <UserInfoBlock />
              <ModeBlock />
              <CoordsBlock/>
              <MiniMapBlock />
              <LegendBlock isVisible={this.props.withLegends}/>
            </div>
            <div className={styles['bottom-right-block']}>
              <MainMap width={MAIN_MAP_WIDTH}/>
            </div>
          </div>
        </React.Fragment>}
      </div>
    </section>);
  }
}

export default branch({
  loaded: BLOCKS.APP.LOADED,
  scale: BLOCKS.APP.SCALE,
  showPopup: BLOCKS.APP.POPUP,
  withLegends: BLOCKS.MINI_MAP.WITH_LEGENDS
}, App);
